var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit/zoom-in"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 9C14.8203 9 9 14.8203 9 22C9 29.1797 14.8203 35 22 35C25.5904 35 28.8377 33.5471 31.1924 31.1924C33.5471 28.8377 35 25.5904 35 22C35 14.8203 29.1797 9 22 9ZM5 22C5 12.6112 12.6112 5 22 5C31.3888 5 39 12.6112 39 22C39 25.9729 37.6353 29.6298 35.3519 32.5235L42.9142 40.0858L40.0858 42.9142L32.5235 35.3519C29.6298 37.6353 25.9729 39 22 39C12.6112 39 5 31.3888 5 22ZM20 20V15L24 15V20H29V24H24V29H20V24H15L15 20H20Z",
    fill: "#4E5969"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoom-in.71f347430fdedc955d5a2a28c7d09d48.svg";
export { ForwardRef as ReactComponent };